module.exports = __webpack_public_path__ + "img/solarfox.ee013517.png";